import gql from 'graphql-tag';
import { client } from '../../apollo';

export async function getZwalletUserAccountGraphQL(accountNumber=1) {
  const QUERY = gql`
    query getZwalletUserAccount {
      zwalletUserAccount(accountNumber: ${accountNumber}) {
          balance,
          incomes,
          outcomes,
          operationsCount,
          futureReleases
      }
    }
  `;

  try {
      const { data } = await client.query({ query: QUERY });

      return data.zwalletUserAccount;
  } catch(error) {
      const msg = error.message.replace("GraphQL error: ", "")
      console.log(msg);
      throw msg
  }
}


// WEBPACK FOOTER //
// ./src/ZWallet/Dashboard/graphql.js